module.exports = __webpack_public_path__ + "static/assets/6962aa568028d2d7a557c165e6ffb4a2.png";